import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {InputNumberModule} from 'primeng/inputnumber';
import {FormsModule} from '@angular/forms';
import {TypeHelper} from '../../../../helper/type.helper';

@Component({
  standalone: true,
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  imports: [
    InputNumberModule,
    FormsModule
  ],
  styleUrls: ['./input-number.component.scss']
})
export class InputNumberComponent implements OnDestroy
{
  @Input() class = 'grid-comp-full-width';
  @Input() styleClass: string;
  @Input() textCenter: boolean;
  @Input() small: boolean;

  @Input() maxLength: number;
  @Input() tabindex: number;
  @Input() allowEmpty = true;
  @Input() selectAllOnFocus = true;
  @Input() inputStyleClass: string;
  @Input() disabled: boolean;
  @Input() classInputgroupRight: boolean;
  @Input() directInput: boolean;
  @Input() placeholder: string;

  @Input() value: number;
  @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() onValueChanged: EventEmitter<number> = new EventEmitter<number>();

  dataChanged = false;
  newValue: number;

  ngOnDestroy(): void
  {
    if (this.dataChanged)
      this.onDataChanged();
  }

  public selectAll(event: any): void
  {
    if (this.selectAllOnFocus)
      event.target.select();
  }

  public onNgModelChange(value: any): void
  {
    this.dataChanged = true;
    this.newValue = value;
    if (this.directInput)
      this.changeData();
  }

  public onDataChanged(): void
  {
    // console.log('onDataChanged, newValue: ' + this.newValue + ', value: ' + this.value);
    if (!this.directInput)
      this.changeData();
  }

  private changeData(): void
  {
    if (this.dataChanged && !TypeHelper.numberEquals(+this.value, this.newValue))
    {
      console.log('Change Data, value: ' + this.value + ', newValue: ' + this.newValue);
      this.valueChange.emit(this.newValue);
      this.onValueChanged.emit(this.newValue);
      this.dataChanged = false;
      this.value = this.newValue;
    }
  }
}
